import { Atom, wrap, Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';
import getIsMobile from "components/atoms/utils/getIsMobile";

const isMobile = getIsMobile();

const borderWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 82px;
    height: 82px;
    border-radius: 50%;
    border: 1px solid ${theme?.colour?.primary ?? '#1DBD6B'};

    @media (min-width: 768px) {
      width: 176px;
      height: 176px;
      border: 2px solid ${theme?.colour?.primary ?? '#1DBD6B'};
    } 
  `}
`
const template = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 63px;
    height: 63px;
    
    svg {
      fill: ${theme?.colour?.primary ?? '#1DBD6B'};
      width: 63px;
      height: 63px;
    }
    
    @media (min-width: 768px) {
      border-radius: 50%;
      background: #FFFFFF ;
      width: 152px;
      height: 152px;

      svg {
      width: 76px;
      height: 80px;
    }
    }
  `}
`;

export default isMobile ? Atom({ type: 'label', dataType: 'object', template }) : wrap(Atom({ type: 'label', dataType: 'object', template }), Wrapper(borderWrapper));